
import {first} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild} from '@angular/router';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthorizationService} from '../shared/authorization.service';
import {KeyValue} from '../shared/key-value';
import {Observable} from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private _tokenService: AngularTokenService,
              public authService:AuthorizationService ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.checkForActivation(KeyValue.allRole, state.url).pipe(first());
  }

}
